import Compressor from "compressorjs/src/index";
export default function compressImg(imgFile,quality = 0.8) {
	return new Promise((resolve, reject) => {
		new Compressor(imgFile, {
			quality: quality,
			success(result) {
				resolve(result);
			},
			error(err) {
				console.log(err.message);
				reject(err);
			},
		});
	});
}
